<template>
  <component :is="component"
             v-if="component"
             :select-goods-id="selectGoodsId"
             :sub-goods-info-list="subGoodsInfoList"
             :sub-goods-composition-info="subGoodsCompositionInfo"
             :display-info="displayInfo"
             :essential-goods-list="essentialGoodsList"
             :default-select-goods-list="defaultSelectGoodsList"
             @add-sub-goods="addSubGoods"
             @remove-sub-goods="removeSubGoods"
             @change-quantity="changeQuantity"
             @change-volume="changeVolume"
  />
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import _ from 'lodash'
import Id3 from "@/components/step1/GoodsTable/SubGoodsTemplate/Id3";
import Id11 from "@/components/step1/GoodsTable/SubGoodsTemplate/Id11";
import Id12 from "@/components/step1/GoodsTable/SubGoodsTemplate/Id12";

export default {
  name: "SubGoodsRowDynamicTemplate",
  props: {
    templateId: {
      type: Number,
    },
    subGoodsCompositionInfo: {
      type: Object,
    },
    selectGoodsId : {
      type : Number
    },
  },
  data() {
    return {
      component: null,
      subGoodsInfoList: [],
      displayInfo: {},
    }
  },
  computed: {
    ...mapGetters({
      subGoodsInfoListFromStore: 'goods_info/getSubGoodsInfoList',
      essentialGoodsList: 'goods_info/getEssentialGoods',
      defaultSelectGoodsList: 'goods_info/getDefaultSelectGoodsList',
    }),
  },
  mounted() {
    if (!this.templateId) {
      return null
    }

    // dynamic import로 처리할 경우 code splitting 이 발생해서 url 변경의 이슈가 발생하여
    // 아래와 같이 하나하나 처리
    switch (this.templateId) {
      case 3:
        this.component =  Id3
        break
      case 11:
        this.component = Id11
        break
      case 12:
        this.component = Id12
        break
    }

    let goodsCompositionTypeIdList = _.chain(this.subGoodsCompositionInfo.rule.group)
        .flatMap(goodsCompositionGroupInfo => parseInt(goodsCompositionGroupInfo.type_id))
        .value();

    this.subGoodsInfoList = this.subGoodsInfoListFromStore(
        this.subGoodsCompositionInfo.main_goods_id,
        goodsCompositionTypeIdList
    )

    this.displayInfo = this.subGoodsCompositionInfo.display_info ? this.subGoodsCompositionInfo.display_info : {}
  },
  methods:{
    ...mapActions({
      addSubGoods :'addSubGoods',
      removeSubGoods: 'removeSubGoods',
      changeQuantity: 'order_info/changeQuantity',
      changeVolume: 'order_info/changeVolume',
    }),
  }
}
</script>

<style scoped lang="scss">
::v-deep .disabled {
  opacity: 0.5;
}
</style>